import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-kbin', 'IconBrandKbin', [["g",{"stroke-width":"1.838","key":"svg-0"}]]);